import { render, staticRenderFns } from "./TheSala.vue?vue&type=template&id=47ec6709&scoped=true&"
import script from "./TheSala.vue?vue&type=script&lang=js&"
export * from "./TheSala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec6709",
  null
  
)

export default component.exports